export const GET_PLANS = 'eventFloodControl/GET_PLANS';
export const GET_PLANS_START = `${GET_PLANS}_START`;
export const GET_PLANS_SUCCESS = `${GET_PLANS}_SUCCESS`;
export const GET_PLANS_FAIL = `${GET_PLANS}_FAIL`;

export function getPlans({ userUuid }) {
  return {
    type: GET_PLANS,
    meta: {
      xmApi: true,
      uri: `/webapi/xm/1/plans/`,
      method: 'getall',
      params: {
        accessibleBy: userUuid,
        embed: 'integrations',
      },
    },
  };
}

export const SAVE_FILTER = 'eventFloodControl/SAVE_FILTER';
export const SAVE_FILTER_START = `${SAVE_FILTER}_START`;
export const SAVE_FILTER_SUCCESS = `${SAVE_FILTER}_SUCCESS`;
export const SAVE_FILTER_FAIL = `${SAVE_FILTER}_FAIL`;

export function saveFilter(plan) {
  return {
    type: SAVE_FILTER,
    meta: {
      xmApi: true,
      uri: `/webapi/xm/1/event-filters/`,
      method: 'post',
      params: plan,
    },
  };
}

export const GET_PLAN_PROPERTIES = 'eventFloodControl/GET_PLAN_PROPERTIES';
export const GET_PLAN_PROPERTIES_START = `${GET_PLAN_PROPERTIES}_START`;
export const GET_PLAN_PROPERTIES_SUCCESS = `${GET_PLAN_PROPERTIES}_SUCCESS`;
export const GET_PLAN_PROPERTIES_FAIL = `${GET_PLAN_PROPERTIES}_FAIL`;

export const getPlanProperties = planUuid => dispatch => {
  if (!window.XM_getPlanProperties) return;

  window.XM_getPlanProperties(planUuid);
  dispatch({
    type: GET_PLAN_PROPERTIES_START,
  });
};
